import { Select, SelectProps } from "antd";
import { AreaComumTipoVencimentoCobrancaEnum } from "core/features/area-comum/typings";
import SelectBaseAntd from "../SelectBaseAntd";

const { Option } = Select;

export interface SelectDataReferenciaBoletoReservaProps<T = any>
  extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
}

function SelectDataReferenciaBoletoReserva({
  value,
  isInvalid,
  onChange,
  ...rest
}: SelectDataReferenciaBoletoReservaProps) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <Option value={AreaComumTipoVencimentoCobrancaEnum.DiaDoEvento} key="e">
          Dia do evento
        </Option>
        <Option
          value={AreaComumTipoVencimentoCobrancaEnum.DiaCriacaoReserva}
          key="c"
        >
          Dia em que criou a reserva
        </Option>
      </SelectBaseAntd>
    </>
  );
}

export default SelectDataReferenciaBoletoReserva;
